import { gql } from 'apollo-boost';

// input GetReviewsInput {
//     period: ReviewPeriodEnum!
//     limit: Int
//     cursor: String
// }

export const GET_REVIEWS = gql`
    query($data: GetReviewsInput!) {
        getReviews(data: $data) {
            reviews {
                id
                localDate
                timezone
                period
                periodKey
                headline
                story { kind title body messageIds sources { messageId title path } }
                summary
                sections {
                    savedCount
                }
                generatedAt
                status
            }
            hasMore
            nextCursor
        }
    }
`;
